import React from "react";

import { toast } from "react-toastify";
import { isEnabled } from "utils/featureFlags";

import { push } from "connected-react-router";

import moment from "moment";

import * as DatasetAPI from "api/DatasetAPI";

import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as setupReducer from "containers/Setup/reducer";

const UPDATE_FIELD = "market/UPDATE_FIELD";

const initialMarket = {
  isCreateJob: false,
  isCreateConsultant: false,
  menuType: "overview",

  consultants: {
    0: {
      id: 0,
      title: "John Doe",
      subtitle: "Data Scientist / USA",
      nProjects: 32,
      nDataProjects: 8,
      nExplorations: 53,
      nDeployments: 34,
      nRatings: 8359,
      nStars: 4,
      contractType: "Data Exploration / AI Creation",
      contractLength: "2 Month",
      cHoursAgo: 2,
      match: 96
    },
    2: {
      id: 2,
      title: "Jay Walker",
      subtitle: "Data Engineer / USA",
      nProjects: 558,
      nDataProjects: 8,
      nExplorations: 20,
      nDeployments: 254,
      nRatings: 332,
      stars: 5,
      contractType: "AI Creation / Deployment",
      contractLength: "6 Month",
      cHoursAgo: 32,
      match: 57
    },
    3: {
      id: 3,
      title: "Dinah Mite",
      subtitle: "Data Scientist / USA",
      nProjects: 7,
      nDataProjects: 800,
      nExplorations: 5047,
      nDeployments: 3,
      nRatings: 4035,
      stars: 5,
      contractType: "Data Exploration",
      contractLength: "Part Time",
      cHoursAgo: 31,
      match: 65
    },
    1: {
      id: 1,
      title: "Al E. Gater",
      subtitle: "Marketing Analyst / USA",
      nProjects: 227,
      nDataProjects: 283,
      nExplorations: 1107,
      nDeployments: 126,
      nRatings: 813,
      stars: 3,
      contractType: "Data Exploration / AI Creation",
      contractLength: "2 Month",
      cHoursAgo: 13,
      match: 81
    }
  },

  jobs: {
    0: {
      id: 0,
      title: "Data Analyst",
      subtitle: "Aible",
      cHoursAgo: 3,
      textBody:
        "Looking for a Data Analyst to assist in the analyzing of datasets, creation of models, and deployment of said models.",
      contractType: "Data Exploration / AI Creation",
      contractLength: "2 Month",
      budget: 150,
      jobActions: "User explored 17 out of 42 recommended graphs. Focused on only 3 variables. Outcome - Revenue"
    },
    1: {
      id: 1,
      title: "Data Engineer",
      subtitle: "Aible",
      cHoursAgo: 12,
      textBody:
        "Looking for a Data Engineer to assist in the analyzing of datasets, creation of models, and deployment of said models.",
      contractType: "AI Creation / Deployment",
      contractLength: "6 Month",
      budget: 125,
      jobActions: "Current dataset has 15 fields from CRM and Marketing. Looking to add 5-10 additional fields"
    },
    2: {
      id: 2,
      title: "Data Scientist",
      subtitle: "Aible",
      cHoursAgo: 31,
      textBody:
        "Looking for a Data Scientist to assist in the analyzing of datasets, creation of models, and deployment of said models.",
      contractType: "Data Exploration",
      contractLength: "Part Time",
      budget: 75,
      jobActions: "No Blueprint, Models created, 3 scenarios created, No subgroups."
    },
    3: {
      id: 3,
      title: "Data Wizard",
      subtitle: "Aible",
      textBody:
        "Looking for a Data Wizard to assist in the analyzing of datasets, creation of models, and deployment of said models.",
      cHoursAgo: 48,
      contractType: "Data Exploration / AI Creation",
      contractLength: "13 Hours",
      budget: 200,
      jobActions: "No Blueprint, Models created, 3 scenarios created, No subgroups."
    }
  },
  blueprints: {
    0: {
      id: 0,
      title: "Sales Optimization",
      outcome: "Revenue",
      columns: 15,
      datasets: 8,
      cHoursAgo: 33,
      nRatings: 22,
      createdBy: "Miles A. Head",
      stars: 3,
      price: 25
    },
    1: {
      id: 1,
      title: "Avocado Prices",
      outcome: "Revenue",
      columns: 12,
      datasets: 3,
      cHoursAgo: 15,
      nRatings: 36,
      createdBy: "Miles A. Head",
      stars: 5,
      price: 30
    },
    2: {
      id: 2,
      title: "Customer Retention",
      outcome: "Churn",
      columns: 19,
      datasets: 5,
      cHoursAgo: 5,
      nRatings: 3,
      createdBy: "Miles A. Head",
      stars: 3,
      price: 125
    },
    3: {
      id: 3,
      title: "Stockout",
      outcome: "Lead Time",
      columns: 8,
      datasets: 17,
      cHoursAgo: 9,
      nRatings: 55,
      createdBy: "Miles A. Head",
      stars: 0,
      price: 50
    }
  },
  datasets: {
    0: {
      id: 0,
      title: "Azure Cosmos",
      description:
        "This dataset was created and stored in the cloud. There are endless possibilities that this dataset could be used for",
      columns: 15,
      rows: 542,
      cHoursAgo: 54,
      nRatings: 22,
      createdBy: "Anita Hug",
      stars: 3,
      price: 34
    },
    1: {
      id: 1,
      title: "DynamoDB",
      description:
        "This dataset was created and stored in the cloud. There are endless possibilities that this dataset could be used for",
      columns: 12,
      rows: 56,
      cHoursAgo: 13,
      nRatings: 36,
      createdBy: "Anita Hug",
      stars: 5,
      price: 78
    },
    2: {
      id: 2,
      title: "MongoDB",
      description:
        "This dataset was created and stored in the cloud. There are endless possibilities that this dataset could be used for",
      columns: 19,
      rows: 2275,
      cHoursAgo: 4,
      nRatings: 3,
      createdBy: "Anita Hug",
      stars: 3,
      price: 22
    },
    3: {
      id: 3,
      title: "SQL Server",
      description:
        "This dataset was created and stored in the cloud. There are endless possibilities that this dataset could be used for",
      columns: 8,
      rows: 48735,
      cHoursAgo: 15,
      nRatings: 55,
      createdBy: "Anita Hug",
      stars: 0,
      price: 15
    }
  }
};

function marketReducer(state = initialMarket, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: action.data
      };
    default:
      return state;
  }
}

/* Selectors */
export function getBase(state) {
  return state.market;
}

export function getConsultants(state) {
  return getBase(state).consultants;
}

export function getConsultantsArr(state) {
  const consultants = getConsultants(state);

  return Object.keys(consultants)
    .map((k) => consultants[k])
    .sort((a, b) => a.cHoursAgo - b.cHoursAgo);
}

export function getJobs(state) {
  return getBase(state).jobs;
}

export function getJobsArr(state) {
  const jobs = getJobs(state);

  return Object.keys(jobs)
    .map((k) => jobs[k])
    .sort((a, b) => a.cHoursAgo - b.cHoursAgo);
}

export function getBlueprints(state) {
  return getBase(state).blueprints;
}

export function getBlueprintsArr(state) {
  const blueprints = getBlueprints(state);

  return Object.keys(blueprints)
    .map((k) => blueprints[k])
    .sort((a, b) => a.cHoursAgo - b.cHoursAgo);
}

export function getDatasets(state) {
  return getBase(state).datasets;
}

export function getDatasetsArr(state) {
  const datasets = getDatasets(state);

  return Object.keys(datasets)
    .map((k) => datasets[k])
    .sort((a, b) => a.cHoursAgo - b.cHoursAgo);
}

export function getIsCreateConsultant(state) {
  return getBase(state).isCreateConsultant;
}

export function getIsCreateJob(state) {
  return getBase(state).isCreateJob;
}

export function getAssignTodo(state) {
  return getBase(state).assignTodo;
}

export function getMenuType(state) {
  return getBase(state).menuType;
}

export function getIsReviewing(state) {
  return getBase(state).isReviewing;
}

export function updateHireConsultant(consultantId, isHire) {
  return (dispatch, getState) => {
    let retConsultants = { ...getConsultants(getState()) };

    retConsultants[consultantId].isHire = isHire;

    return dispatch(updateConsultants(retConsultants));
  };
}

export function updateHireJob(jobId, isHire) {
  return (dispatch, getState) => {
    let retJobs = { ...getJobs(getState()) };

    retJobs[jobId].isHire = isHire;

    return dispatch(updateJobs(retJobs));
  };
}

export function createConsultant(consultant) {
  return (dispatch, getState) => {
    let retConsultants = { ...getConsultants(getState()) };

    const nConsultantId = consultant?.id !== undefined ? consultant?.id : Object.keys(retConsultants).length;

    retConsultants[nConsultantId] = {
      ...consultant,
      id: nConsultantId,
      nProjects: 0,
      nDataProjects: 0,
      nExplorations: 0,
      nDeployments: 0,
      nRatings: 0,
      stars: 0,
      cHoursAgo: 0,
      isOwner: true
    };

    dispatch(updateConsultants(retConsultants));
    dispatch(updateIsCreateConsultant(false));
    return dispatch(updateMenuType("hire consultants"));
  };
}

export function createJob(job) {
  return (dispatch, getState) => {
    let retJobs = { ...getJobs(getState()) };

    const nJobId = job?.id !== undefined ? job?.id : Object.keys(retJobs).length;

    retJobs[nJobId] = {
      ...job,
      id: nJobId,
      cHoursAgo: 0,
      isOwner: true
    };

    dispatch(updateJobs(retJobs));
    dispatch(updateIsCreateJob(false));

    toast(
      <div
        onClick={() => {
          dispatch(push("/market"));
          return dispatch(updateMenuType("manage jobs"));
        }}
      >
        {"Your new Job has been posted! Click here to go to the marketplace and view your job."}
      </div>,
      {
        type: toast.TYPE.SUCCESS,
        position: toast.POSITION.TOP_CENTER,
        autoClose: 7500
      }
    );

    return Promise.resolve();
  };
}

export function deleteConsultant(consultantId) {
  return (dispatch, getState) => {
    let retConsultants = { ...getConsultants(getState()) };

    delete retConsultants[consultantId];

    return dispatch(updateConsultants(retConsultants));
  };
}

export function deleteJob(jobId) {
  return (dispatch, getState) => {
    let retJobs = { ...getJobs(getState()) };

    delete retJobs[jobId];

    return dispatch(updateJobs(retJobs));
  };
}

export function viewConsultants() {
  return (dispatch, getState) => {
    dispatch(push("/market"));
    return dispatch(updateMenuType("hire consultants"));
  };
}

export function updateConsultants(consultants) {
  return { type: UPDATE_FIELD, key: "consultants", data: consultants };
}

export function updateJobs(jobs) {
  return { type: UPDATE_FIELD, key: "jobs", data: jobs };
}

export function updateIsCreateConsultant(isCreateConsultant) {
  return {
    type: UPDATE_FIELD,
    key: "isCreateConsultant",
    data: isCreateConsultant
  };
}

export function updateIsReviewingJob(isReviewing) {
  return { type: UPDATE_FIELD, key: "isReviewing", data: isReviewing };
}

export function createTodo(todo) {
  return (dispatch, getState) => {
    console.log("create todo", todo);

    const activeTab = nextReducer.getActiveTab(getState(), todo?.nextId);

    if (activeTab === "EXPLORE" || activeTab === "DASHBOARD") {
      dispatch(nextReducer.updateNodeAssign(todo?.nextId, todo?.node, todo));
    } else {
      const projectId = nextReducer.getProjectId(getState(), todo?.nextId);
      const activeSegment = projectReducer.getActiveSegment(getState(), projectId);

      if (activeSegment?.tasks) {
        const dupeTask = activeSegment.tasks.find(
          (task) => task?.type === todo?.node?.id && task?.assigned_to?.id === todo?.assigneeId
        );

        if (dupeTask !== undefined) {
          return toast(<div>{"This task has already been assigned to this user!"}</div>, {
            type: toast.TYPE.SUCCESS,
            position: toast.POSITION.TOP_CENTER,
            autoClose: 7500
          });
        }
      }

      dispatch(nextModelsReducer.updateNodeAssign(todo?.nextId, todo?.node, todo));
    }

    toast(
      <div>
        {todo?.node?.isDashboard
          ? "You have shared the Dashboard! " + todo?.assignee + " will be notified."
          : "You have created a new assignment! " + todo?.assignee + " will be notified."}
      </div>,
      {
        type: toast.TYPE.SUCCESS,
        position: toast.POSITION.TOP_CENTER,
        autoClose: 7500
      }
    );

    return dispatch({
      type: UPDATE_FIELD,
      key: "assignTodo",
      data: undefined
    });
  };
}

export function assignTodo(nextId, todo) {
  return (dispatch, getState) => {
    console.log("assign todo", todo);

    const projectId = nextReducer.getProjectId(getState(), nextId);
    const project = projectReducer.getProject(getState(), projectId);
    const runId = projectReducer.getRunId(getState(), projectId);
    const datasetId = setupReducer.getDatasetId(getState(), runId) || nextReducer.getDatasetId(getState(), nextId);

    const dataset = homeReducer.getDataset(getState(), datasetId);

    const node = todo?.node || todo?.mNode;

    const activeTab = nextReducer.getActiveTab(getState(), nextId);

    const hexMap = nextReducer.getHexMap(getState(), nextId);
    let chartCount = 0;

    Object.keys(hexMap).forEach((hKey) => hexMap[hKey].forEach((node) => chartCount++));

    const assignTodo =
      todo === undefined
        ? undefined
        : activeTab === "EXPLORE"
          ? {
              nextId: nextId,
              title: "Aible User - Exploration",
              subTitle: "Aible",
              contractType: "Data Exploration",
              contractLength: "8 Hours",
              budget: 120,
              rateType: "Per Hour",
              textBody:
                "Assigning the chart: " +
                node?.text +
                ". The exploration contains " +
                chartCount +
                " charts in total. The dataset that was used is " +
                dataset?.name +
                " and it has " +
                dataset?.rowCount +
                " rows and " +
                (dataset ? Object.keys(dataset.fields).length : 0) +
                " fields. The outcome for the dataset is " +
                dataset.outcome,
              modelStepId: node?.id,
              node: node,
              todo: todo,
              assignee: todo?.assignee
            }
          : {
              nextId: nextId,
              title: "Aible User - AI Creation",
              subTitle: "Aible",
              contractType: "AI Creation / Deployment",
              contractLength: "8 Hours",
              budget: 120,
              rateType: "Per Hour",
              textBody: node?.isDashboard
                ? "Sharing my Dashboard, please come take a look. " +
                  "The dataset that was used is " +
                  dataset?.name +
                  " and it has " +
                  dataset?.rowCount +
                  " rows and " +
                  Object.keys(dataset.fields).length +
                  " fields."
                : "Assigning the task: " +
                  node?.text +
                  ". The project contains " +
                  project?.segment_count +
                  " subgroups. " +
                  "The dataset that was used is " +
                  dataset?.name +
                  " and it has " +
                  dataset?.rowCount +
                  " rows and " +
                  Object.keys(dataset.fields).length +
                  " fields.",
              modelStepId: node?.id,
              node: node,
              todo: todo,
              assignee: todo?.assignee
            };

    return dispatch({
      type: UPDATE_FIELD,
      key: "assignTodo",
      data: assignTodo
    });
  };
}

export function updateIsCreateJob(isCreateJob, props) {
  return (dispatch, getState) => {
    let retIsCreate = isCreateJob;

    if (props?.id !== undefined) {
      const nNodes = Object.keys(nextModelsReducer.getHexMap(getState(), props.id))
        .map((h) => nextModelsReducer.getHexMap(getState(), props.id)[h])
        .filter((n) => n.text !== "Blueprint");
      const cNodes = Object.keys(nextModelsReducer.getSavedHexMap(getState(), props.id))
        .map((h) => nextModelsReducer.getSavedHexMap(getState(), props.id)[h])
        .filter((n) => n.text !== "Dataset Name" && n.text !== "Marketing Use Case");

      const projectId = nextReducer.getProjectId(getState(), props.id);
      const datasetId = nextReducer.getDatasetId(getState(), props.id);

      const blueprintId = projectReducer.getBlueprintId(getState(), projectId);

      const blueprint = blueprintId !== undefined ? blueprintReducer.getBlueprint(getState(), blueprintId) : undefined;

      const dataset = homeReducer.getDataset(getState(), datasetId);

      const selectedModelNode = nextModelsReducer.getSelectedHex(getState(), props.id);

      retIsCreate = {
        nextId: props.id,
        title: "Aible User - AI Creation",
        subTitle: "Aible",
        contractType: "AI Creation / Deployment",
        contractLength: "8 Hours",
        budget: 120,
        rateType: "Per Hour",
        textBody:
          (selectedModelNode === undefined
            ? "Model creation has not been started. "
            : "Currently on step: " + selectedModelNode?.text + ". ") +
          (blueprint === undefined ? "Not using a blueprint. " : "Using blueprint: " + blueprint?.name + ". ") +
          "Have completed " +
          cNodes.length +
          " steps for model creation. Have " +
          nNodes.length +
          " remaining steps: " +
          nNodes.reduce((a, b) => a + (a.length === 0 ? "" : ", ") + b.text, "") +
          ". Dataset contains " +
          dataset?.rowCount +
          " rows and " +
          (dataset.fields ? Object.keys(dataset.fields).length : "") +
          " columns. " +
          "No derived variables have been created.",
        suppressModal: props?.noModal
      };
    }

    return dispatch({
      type: UPDATE_FIELD,
      key: "isCreateJob",
      data: retIsCreate
    });
  };
}

export function updateMenuType(menuType) {
  return { type: UPDATE_FIELD, key: "menuType", data: menuType };
}

export default marketReducer;
